import type { FlagType, FlagValue } from '@anchorage/feature-flags';

export const inferType = (value: FlagValue): FlagType => {
  if (typeof value === 'boolean') {
    return 'boolean';
  }
  if (typeof value === 'string') {
    return 'string';
  }
  if (typeof value === 'number') {
    return 'number';
  }
  return 'object';
};

export const hasUnsavedChanges = (
  editingFlags: Record<string, FlagValue> | null,
  key: string,
  currentValue: FlagValue,
): boolean => {
  if (!editingFlags) {
    return false;
  }
  const editedValue = editingFlags[key];
  if (editedValue === undefined) {
    return false;
  }
  return JSON.stringify(editedValue) !== JSON.stringify(currentValue);
};
